export default "__VITE_ASSET__Dt9JE8nV__"